import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #3d1361;
  margin-bottom: 24px;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

interface PaymentCardProps {
  selected: boolean;
  hidden?: boolean;
}

export const PaymentCard = styled.div<PaymentCardProps>`
  overflow: hidden;

  cursor: pointer;

  border: ${({ selected, hidden }) =>
    selected ? '2px solid #5b1e8c' : '1px solid #ececec'};

  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);

  &:hover {
    transform: translateY(-2px);

    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);

    background-color: #f9f9f9b2;
  }
  border-radius: 20px;

  transition: opacity 0.6s ease, transform 0.6s ease, max-height 0.6s ease,
    padding 0.6s ease, margin 0.6s ease;

  opacity: ${({ hidden }) => (hidden ? 0 : 1)};

  transform: ${({ hidden }) =>
    hidden ? 'translateY(-30px)' : 'translateY(0)'};

  max-height: ${({ hidden }) => (hidden ? '0px' : '300px')};

  margin-top: ${({ hidden }) => (hidden ? '0px' : '12px')};

  padding: ${({ hidden }) => (hidden ? '0px' : '16px')};

  pointer-events: ${({ hidden }) => (hidden ? 'none' : 'auto')};

  @media (max-width: 800px) {
    max-width: 300px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .selected-google-pay {
    width: 100%;
    height: 48px;
    background: #000;
    border-radius: 8px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .selected-google-apple {
    display: flex;
    justify-content: space-between;
    height: 24px;
  }

  .selected-google-apple img {
    min-height: 40px;
    width: auto;
  }

  .apple-pay-btn-wrapper .apple-pay-btn {
    min-height: 40px;
    span {
      min-height: 40px;
    }
    button {
      min-height: 40px;
    }
  }
  .wallets {
    display: flex;
    justify-content: left;
    flex-direction: row;
    color: var(--purple);
    align-items: center;

    svg {
      font-size: 24px;
    }
  }
`;

export const CardTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CardTitle = styled.h2`
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  color: #40115f;
  margin-left: 5px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e8e8e8;
  margin: 16px 0;
`;

export const CardInfo = styled.div<{
  collapsed: boolean;
}>`
  overflow: hidden;

  max-height: 80px;

  opacity: 1;

  margin-top: 12px;

  transition: max-height 0.3s ease, opacity 0.2s ease, margin-top 0.2s ease;
`;

export const WarningText = styled.p`
  margin-top: 12px;
  font-size: 15px;
  color: #d36a2e;
  line-height: 1.4;
`;
